import { createFileRoute, redirect } from '@tanstack/react-router'
import { CreditNoteCreateScreen } from '@/features/accounting-invoices/credit-note-create-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/invoices/$invoiceId/credit-note')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_invoice_credit.create')) {
      throw redirect({ to: '/accounting/invoices' })
    }
  },
  component: CreditNoteCreateRoute,
})

function CreditNoteCreateRoute() {
  const { invoiceId } = Route.useParams()
  return <CreditNoteCreateScreen invoiceId={invoiceId} />
}
